import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LoginForm from '@/components/auth/LoginForm';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

const Login: React.FC = () => {
  const { user, loading, session } = useAuth();
  const navigate = useNavigate();

  // Enhanced redirect logic
  useEffect(() => {
    console.log('Login page mount check - Auth status:', {
      isAuthenticated: !!user && !!session,
      isLoading: loading,
      userId: user?.id,
      sessionExpiry: session?.expires_at
        ? new Date(session.expires_at * 1000).toISOString()
        : 'no session',
    });

    // Only redirect if user is authenticated and not in loading state
    if (user && session && !loading) {
      console.log('User authenticated, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [user, session, loading, navigate]);

  // If loading, show a simplified loading state
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col justify-center items-center">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-muted-foreground">Trwa ładowanie...</p>
      </div>
    );
  }

  // Only render login form if user is not authenticated
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="bg-card rounded-lg shadow-lg p-8 border border-border">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block">
              <div className="flex items-center justify-center">
                <img
                  src="/lovable-uploads/090e7638-138e-49cc-922f-47dcf438b646.png"
                  alt="MediCert Logo"
                  className="h-12 w-auto"
                />
              </div>
            </Link>
            <h2 className="text-xl font-semibold mt-6 mb-2">Witaj ponownie</h2>
            <p className="text-muted-foreground">Zaloguj się do swojego konta</p>
          </div>

          <LoginForm />

          <div className="mt-8 pt-6 border-t text-center">
            <p className="text-xs text-muted-foreground mb-4">
              Kontynuując, zgadzasz się na nasze{' '}
              <a href="#" className="text-primary hover:underline">
                Warunki korzystania
              </a>{' '}
              i{' '}
              <a href="#" className="text-primary hover:underline">
                Politykę prywatności
              </a>
              .
            </p>

            <Link to="/">
              <Button variant="ghost" className="text-sm">
                Powrót do strony głównej
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
